import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const API = process.env.REACT_APP_BACKEND_URL;

export const CloudApproval = ({ onLogin }) => {
  const [token, setToken] = useState(localStorage.getItem('admin_token') || '');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [device, setDevice] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const command = async action => {
    setBusy(true); setError('');
    try {
      const login = action === 'login';
      const r = await fetch(`${API}/api/${login ? 'admin/login' : `pos/auth/cloud/${action}`}`, { method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify(login ? { username, password } : { code }) });
      if (!r.ok) {
        if (r.status === 401) setToken('');
        throw new Error();
      }
      const data = await r.json();
      if (login) { setToken(data.token); setPassword(''); localStorage.setItem('admin_token', data.token); onLogin && onLogin(data.token); } else setDevice(data);
    } catch { setError('Админ эрх эсвэл холбох кодыг шалгана уу.'); }
    finally { setBusy(false); }
  };
  return <section data-testid="cloud-approval-panel" className="space-y-6">
    <h2 data-testid="cloud-approval-heading" className="text-lg font-semibold">Windows POS зөвшөөрөл</h2>
    {!token ? <form data-testid="cloud-approval-login-form" className="space-y-4" onSubmit={e => { e.preventDefault(); command('login'); }}>
      <label className="block text-sm">Админ нэр<Input data-testid="cloud-approval-username" autoComplete="username" value={username} onChange={e => setUsername(e.target.value)} required /></label>
      <label className="block text-sm">Нууц үг<Input data-testid="cloud-approval-password" autoComplete="current-password" type="password" value={password} onChange={e => setPassword(e.target.value)} required /></label>
      <Button data-testid="cloud-approval-login" disabled={busy} type="submit">Нэвтрэх</Button>
    </form> : <>
      <form data-testid="cloud-approval-code-form" className="space-y-4" onSubmit={e => { e.preventDefault(); command('inspect'); }}>
        <label className="block text-sm">POS холбох код<Input data-testid="cloud-approval-code" maxLength={12} autoComplete="off" value={code} onChange={e => { setCode(e.target.value.toUpperCase().replace(/[^A-Z2-7]/g, '')); setDevice(null); }} /></label>
        <Button data-testid="cloud-approval-inspect" disabled={busy || code.length !== 12}>Шалгах</Button>
      </form>
      {device && <div data-testid="cloud-approval-confirmation" className="space-y-4 border-t pt-4">
        <p data-testid="cloud-approval-club" className="font-semibold break-words">{device.club_name}</p>
        <p data-testid="cloud-approval-fingerprint" className="font-mono text-xs break-all">{device.device_id}</p>
        {device.status === 'approved' ? <p data-testid="cloud-approval-success" role="status">Зөвшөөрөл олгосон. POS дээр нэвтэрнэ үү.</p> :
          <Button data-testid="cloud-approval-approve" disabled={busy} onClick={() => command('approve')}>Энэ клубтэй холбохыг зөвшөөрөх</Button>}
      </div>}
      <Button data-testid="cloud-approval-switch-admin" variant="ghost" onClick={() => { setToken(''); setDevice(null); }}>Өөр админаар нэвтрэх</Button>
    </>}
    {error && <p data-testid="cloud-approval-error" role="alert" className="text-sm text-red-500">{error}</p>}
  </section>;
};